let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9PiEU")).then(() => parcelRequire('iJQmu'));